import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import DashboardPlugin from './plugins/dashboard-plugin';
import QuarterMinutes from './plugins/quarterMinutes';
import App from './App.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faUserSecret);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// router setup
import i18n from './i18n';
import router from './routes/starterRouter';
import './registerServiceWorker';
import { setDefaultOptions } from 'esri-loader';
setDefaultOptions({ version: '4.19' })

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(QuarterMinutes);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n
});
